import { getConfiguration } from "../utils/configuration";

export function registerGlobalStatsEvents(): void {
	window.addEventListener("keydown", (e) => {
		if (e.key !== "Enter") {
			return;
		}

		const path: Array<HTMLElement> = [];
		for (const node of e.composedPath().reverse()) {
			if (node instanceof HTMLElement && node.tagName.toLowerCase().startsWith("oz-")) {
				path.push(node);
			}
		}

		if (path.length > 0 && FORM_ELEMENT_NAMES.includes(path[path.length - 1].tagName.toLowerCase())) {
			const names = path.map((el) => el.tagName.toLowerCase());

			dataLayer.push({
				event: "stats_form_submit_by_enter",
				language_code: getConfiguration().languageCode,
				element_name: names[names.length - 1],
				path: names.join(" "),
			});
		}
	});
}

const FORM_ELEMENT_NAMES: Array<string> = [
	"oz-checkbox",
	"oz-mega-button",
	"oz-menu",
	"oz-menu-item",
	"oz-picker",
	"oz-radio",
	"oz-slider",
	"oz-switch",
	"oz-textfield",
	"oz-money-field",
	"oz-number-field",
	"oz-phone-field",
	"oz-zip-code-field",
];
